module.exports = __webpack_public_path__ + "static/clients-lark.d3358dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/clients-lark.png
// module id = 932
// module chunks = 241767136424496